import React from 'react';
import { CheckIcon } from 'tdesign-icons-react';
import { Collapse, Card } from 'tdesign-react';
import JsonView from 'react18-json-view';
import { DeepSeekingCom } from '../components';
import { copyToClipboard } from '../utils';

const { Panel } = Collapse;

/**
 * 复制图标组件
 */
const CopyIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8667 3H11.6667H8.13332H6.0531C6.07427 2.89777 6.10389 2.80931 6.14531 2.72801C6.27315 2.47713 6.47712 2.27316 6.728 2.14532C7.01322 2 7.38659 2 8.13332 2H11.8667C12.6134 2 12.9868 2 13.272 2.14532C13.5229 2.27316 13.7268 2.47713 13.8547 2.72801C14 3.01323 14 3.3866 14 4.13333V9.2C14 9.94674 14 10.3201 13.8547 10.6053C13.7268 10.8562 13.5229 11.0602 13.272 11.188C13.1907 11.2294 13.1022 11.259 13 11.2802V4.33333L13 4.32807V4.13333C13 3.74346 12.9992 3.5112 12.9851 3.33903C12.9766 3.23396 12.9652 3.18979 12.9616 3.17795C12.9302 3.11843 12.8816 3.06979 12.822 3.03843C12.8102 3.03476 12.766 3.02343 12.661 3.01484C12.4888 3.00078 12.2565 3 11.8667 3ZM12.8255 3.03964L12.8235 3.03889L12.8249 3.03937C12.8253 3.03954 12.8255 3.03963 12.8255 3.03964ZM12.9605 3.17494C12.9604 3.17462 12.9604 3.17448 12.9604 3.1745L12.9611 3.17652C12.9609 3.17579 12.9607 3.17527 12.9605 3.17494ZM4.13333 5C3.74346 5 3.5112 5.00078 3.33903 5.01484C3.23396 5.02343 3.18979 5.03476 3.17795 5.03843C3.11843 5.06979 3.06979 5.11843 3.03843 5.17795C3.03476 5.18979 3.02343 5.23396 3.01484 5.33903C3.00078 5.5112 3 5.74346 3 6.13333V11.8667C3 12.2565 3.00078 12.4888 3.01484 12.661C3.02343 12.766 3.03476 12.8102 3.03843 12.8221C3.06979 12.8816 3.11843 12.9302 3.17795 12.9616C3.18978 12.9652 3.23395 12.9766 3.33903 12.9852C3.5112 12.9992 3.74346 13 4.13333 13H9.86667C10.2565 13 10.4888 12.9992 10.661 12.9852C10.766 12.9766 10.8102 12.9652 10.8221 12.9616C10.8816 12.9302 10.9302 12.8816 10.9616 12.8221C10.9652 12.8102 10.9766 12.766 10.9852 12.661C10.9992 12.4888 11 12.2565 11 11.8667V6.13333C11 5.74346 10.9992 5.5112 10.9852 5.33903C10.9766 5.23396 10.9652 5.18979 10.9616 5.17795C10.9302 5.11843 10.8816 5.06979 10.822 5.03843C10.8102 5.03476 10.766 5.02343 10.661 5.01484C10.4888 5.00078 10.2565 5 9.86667 5H4.13333ZM10.8255 5.03964L10.8235 5.03889C10.8249 5.03936 10.8255 5.03962 10.8255 5.03964ZM10.9604 5.1745C10.9604 5.17446 10.9606 5.1751 10.9611 5.17652L10.9604 5.1745ZM10.9604 12.8255L10.9611 12.8235C10.9606 12.8249 10.9604 12.8255 10.9604 12.8255ZM10.8255 12.9604C10.8255 12.9604 10.8249 12.9606 10.8235 12.9611L10.8255 12.9604ZM3.1745 12.9604L3.17652 12.9611C3.17509 12.9606 3.17446 12.9604 3.1745 12.9604ZM3.03964 12.8255C3.03962 12.8255 3.03936 12.8249 3.03889 12.8235L3.03964 12.8255ZM3.03964 5.1745L3.03889 5.17652C3.03936 5.1751 3.03962 5.17446 3.03964 5.1745ZM3.1745 5.03964C3.17446 5.03962 3.1751 5.03936 3.17652 5.03889L3.1745 5.03964ZM2 6.13333C2 5.3866 2 5.01323 2.14532 4.72801C2.27316 4.47713 2.47713 4.27316 2.72801 4.14532C3.01323 4 3.3866 4 4.13333 4H9.86667C10.6134 4 10.9868 4 11.272 4.14532C11.5229 4.27316 11.7268 4.47713 11.8547 4.72801C12 5.01323 12 5.3866 12 6.13333V11.8667C12 12.6134 12 12.9868 11.8547 13.272C11.7268 13.5229 11.5229 13.7268 11.272 13.8547C10.9868 14 10.6134 14 9.86667 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V6.13333Z" fill="#030A26" fillOpacity="0.65" />
  </svg>
);

/**
 * OpenResult 渲染器 - 用于大模型智能抽取结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {boolean} props.isLoading - 是否加载中
 */
const OpenResultRenderer = ({ params, config, isLoading }) => {
  const jsonRes = config.jsonRes || 'StructuralList';

  const handleCopy = () => {
    copyToClipboard(params[jsonRes]);
  };

  return (
    <>
      <Collapse
        className="OpenResult_thinking"
        borderless
        defaultValue="default"
        expandIcon
        expandIconPlacement="right"
        expandOnRowClick
      >
        <Panel value="default" header={isLoading ? '思考中' : '已思考'}>
          <span style={{ whiteSpace: 'pre-line' }}>
            {isLoading && !params.ThoughtContent ? '...' : params.ThoughtContent}
          </span>
        </Panel>
      </Collapse>

      {isLoading ? (
        <DeepSeekingCom />
      ) : (
        params[jsonRes]?.length > 0 && (
          <>
            <div className="OpenResult_tips">
              <CheckIcon className="OpenResult_tips__icon" />
              根据您配置的字段,我们为您抽取出如下结果
            </div>
            <Card
              bordered
              headerBordered
              title="JSON"
              actions={
                <i onClick={handleCopy} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <CopyIcon />
                  <span style={{ marginLeft: '4px' }}>复制</span>
                </i>
              }
              hoverShadow
              style={{ width: '100%' }}
            >
              <JsonView
                src={params[jsonRes]}
                keyName={false}
                theme="winter-is-coming"
                displayDataTypes={false}
              />
            </Card>
          </>
        )
      )}
    </>
  );
};

export default OpenResultRenderer;
